import { useEffect, useState, useContext, Fragment } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import {
  createQueryString,
  sendApiRequest,
  transfromDate,
} from "../../services/Base/base-service";

import Breadcrumbs from "./Breadcrumbs";
import UserContext from "../../store/user-context";
import DatePicker from "react-datepicker";
import {
  Col,
  Button,
  Icon,
  Select,
  Chip,
  ChipLabel,
  Alert,
  Label,
  FormGroup,
  Input,
  Row,
} from "design-react-kit";

import "../../assets/Filters.css";
import "react-datepicker/dist/react-datepicker.css";

const Filters = (props) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [typology, setTypology] = useState(null);
  const [typologyOptions, setTypologyOptions] = useState(null);
  const [flowStatusesOptions, setFlowStatusesOptions] = useState(null);
  const [statuses, setStatus] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isFilted, setIsFiltered] = useState(false);
  const [error, setError] = useState(null);
  const [filterCodes, setFilterCodes] = useState(null);
  const [selectedFilterCodes, setSelectedFilterCodes] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const todayDate = new Date();
  const dateNinetyDaysEarlier = new Date();
  dateNinetyDaysEarlier.setDate(todayDate.getDate() - 90);

  const maxDate =
    props.page === "home" || props.page === "externalFlows"
      ? transfromDate(todayDate)
      : null;
  const minDate =
    props.page === "home" || props.page === "externalFlows"
      ? transfromDate(dateNinetyDaysEarlier)
      : null;

  const [selectedFilters, setSelectedFilters] = useState({
    typology: null,
    startDate:
      props.page === "home" || props.page === "externalFlows"
        ? dateNinetyDaysEarlier
        : null,
    endDate:
      props.page === "home" || props.page === "externalFlows"
        ? todayDate
        : null,
    flowStatus: null,
  });

  const formatOptionLabel = ({ value, label, descriptionLong }) => (
    <span title={descriptionLong}>{label}</span>
  );

  useEffect(() => {
    if (
      props.getFilters !== undefined &&
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      if (props.page === "home" || props.page === "externalFlows") {
        props.getFilters({
          fiscalCode: userContext.selectedClientFiscalCode,
          codes: null,
          fromDate: minDate,
          toDate: maxDate,
          flowStatuses: null,
        });
      } else {
        props.getFilters({
          fiscalCode: userContext.selectedClientFiscalCode,
          codes: null,
          fromDate: null,
          toDate: null,
          flowStatuses: null,
        });
      }
    }
    if (
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      let clientApiMethod = "";
      if (props.page === "externalFlows") {
        clientApiMethod = "Client/GetAllClientCodesWithExternalConfiguration";
      } else if (
        props.page === "authModuleFlows" ||
        props.page === "authModuleFlowsEcon" ||
        props.page === "authModuleFlowsNotValid" ||
        props.page === "authModuleFlowsNotCalculated" ||
        props.page === "authModuleFlowsNotValid" ||
        props.page === "authModuleArchive"
      ) {
        clientApiMethod = "Client/GetAllClientCodesWithStagedFlowConfiguration";
      } else {
        clientApiMethod = "Client/GetAllClientCodes";
      }
      setTimeout(() => {
        sendApiRequest(
          clientApiMethod,
          "GET",
          true,
          { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
          signIn,
          signOut,
          navigate,
          createQueryString,
          userContext
        ).then((response) => {
          if (response !== undefined) {
            if (response.errors !== null) {
              setError(response.errors);
            } else {
              let clientCodes = [];
              response.data.map((item) =>
                clientCodes.push({
                  value: item.code,
                  label: item.name,
                })
              );
              setTypologyOptions(clientCodes);
              setTimeout(() => {
                let apiMethod = "";
                if (props.page === "externalFlows") {
                  apiMethod = "Common/GetAllExternalFlowStatuses";
                } else if (props.page === "home") {
                  apiMethod = "Common/GetAllFlowStatuses";
                } else if (props.page === "authModuleFlows") {
                  apiMethod = "Common/GetStagedFlowStatusesForTechAuth";
                } else if (props.page === "authModuleFlowsEcon") {
                  apiMethod = "Common/GetStagedFlowStatusesForEconAuth";
                } else if (props.page === "authModuleFlowsNotValid") {
                  apiMethod = "Common/GetStagedFlowStatusesForNotValidAuth";
                } else if (props.page === "authModuleArchive") {
                  apiMethod = "Common/GetStagedFlowStatusesForArchive";
                } else {
                  return;
                }

                sendApiRequest(
                  apiMethod,
                  "GET",
                  true,
                  {
                    fiscalCode: userContext.selectedClientFiscalCode,
                    flowId: null,
                  },
                  signIn,
                  signOut,
                  navigate,
                  createQueryString,
                  userContext
                ).then((response) => {
                  if (response !== undefined) {
                    if (response.errors !== null) {
                      setError(response.errors);
                    } else {
                      let statuses = [];
                      response.data.forEach((item) => {
                        if (
                          props.page === "authModuleFlows" ||
                          props.page === "authModuleFlowsEcon" ||
                          props.page === "authModuleFlowsNotValid" ||
                          props.page === "authModuleArchive"
                        ) {
                          statuses.push({
                            value: item.name,
                            label: item.label,
                            descriptionLong: item.description,
                          });
                        } else {
                          statuses.push({
                            value: item.name,
                            label: item.description,
                            descriptionLong: item.descriptionLong,
                          });
                        }
                      });
                      setFlowStatusesOptions(statuses);
                    }
                  }
                });
              }, 800);
            }
          }
        });
      }, 300);
      setSelectedFilters({
        ...selectedFilters,
        typology: null,
        flowStatus: null,
      });
      setIsFiltered(true);
      if (props.page === "home") {
        setStartDate(dateNinetyDaysEarlier);
        setEndDate(todayDate);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientName, userContext.selectedClientFiscalCode]);

  const applyFilters = () => {
    const selectedTypology =
      typology !== null ? typology.map((client) => client.value) : [null];

    const selectedStatuses =
      statuses !== null
        ? statuses.map((status) =>
            props.page === "authModuleFlows" ||
            props.page === "authModuleFlowsEcon" ||
            props.page === "authModuleFlowsNotValid" ||
            props.page === "authModuleArchive"
              ? status.label
              : status.value
          )
        : [null];

    if (
      props.getFilters !== undefined &&
      userContext.selectedClientName !== null &&
      userContext.selectedClientFiscalCode !== null
    ) {
      const toDate = endDate !== null ? transfromDate(endDate) : null;
      const fromDate = startDate !== null ? transfromDate(startDate) : null;

      props.getFilters({
        fiscalCode: userContext.selectedClientFiscalCode,
        codes: selectedTypology,
        fromDate: fromDate,
        toDate: toDate,
        flowStatuses: selectedStatuses,
      });
    }
    setIsFiltered(true);
    setFiltersOpen(false);
    setSelectedFilters({
      typology: typology,
      flowStatus: statuses,
      startDate: startDate,
      endDate: endDate,
    });
  };

  const clearFilters = () => {
    setTypology([]);
    setStatus([]);
    if (props.page === "home") {
      setStartDate(dateNinetyDaysEarlier);
      setEndDate(todayDate);
    } else {
      setStartDate(null);
      setEndDate(null);
    }

    setFilterCodes(null);
    const readyFlowFilter = document.querySelector(".readyFlows-filters");
    if (readyFlowFilter !== null) {
      const inputs = document.querySelectorAll(".readyFlows-filters input");
      inputs.forEach((item) => (item.checked = false));
    }
  };

  const toggleFilterOpen = () => {
    setEndDate(selectedFilters.endDate);
    setStartDate(selectedFilters.startDate);
    setStatus(selectedFilters.flowStatus);
    setTypology(selectedFilters.typology);
    setFiltersOpen((oldState) => !oldState);
    setFilterCodes(selectedFilterCodes);
    setTimeout(() => {
      selectedFilterCodes !== null &&
        selectedFilterCodes.forEach((code) => {
          const el = document.getElementById(code);
          if (el !== null) {
            el.checked = true;
          }
        });
    }, 300);
  };

  const handleTypologyChange = (selectedOption) => setTypology(selectedOption);
  const handleStatusChange = (selectedOption) => {
    setStatus(selectedOption);
  };

  return (
    <Fragment>
      {(props.page === "home" ||
        props.page === "authModuleFlows" ||
        props.page === "authModuleFlowsEcon" ||
        props.page === "authModuleFlowsNotValid" ||
        props.page === "authModuleArchive") && (
        <div className="w-100 subheader">
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {error === null && (
            <div className="ml-2 d-flex align-items-center justify-content-between">
              <Breadcrumbs page={props.page} />
              <Button
                outline
                color="secondary"
                onClick={toggleFilterOpen}
                className="mr-5 filters rounded-0"
              >
                Filtri
                {!filtersOpen && <Icon icon="it-expand" className="icon" />}
                {filtersOpen && <Icon icon="it-collapse" className="icon" />}
              </Button>
            </div>
          )}
          {filtersOpen && (
            <div className="pb-2 w-100 mb-3 mt-3">
              <div className="d-flex align-items-start col-12 row">
                <div className="bootstrap-select-wrapper col-8 col-sm-6 col-md-3 mb-4">
                  <label htmlFor="clients">Tipologia</label>
                  <Select
                    id="clients"
                    isMulti={true}
                    isSearchable={true}
                    onChange={handleTypologyChange}
                    options={typologyOptions}
                    value={typology}
                    placeholder="-Seleziona-"
                    aria-label="Seleziona"
                  />
                </div>
                <div className="bootstrap-select-wrapper col-8 col-sm-6 col-md-4 mb-4">
                  <label htmlFor="status">Stato</label>
                  <Select
                    id="status"
                    isMulti={true}
                    isSearchable={true}
                    onChange={handleStatusChange}
                    options={flowStatusesOptions}
                    value={statuses}
                    formatOptionLabel={formatOptionLabel}
                    placeholder="-Seleziona- (l'elenco di stati segue un ordine cronologico)"
                    aria-label="Seleziona"
                  />
                </div>
                <div className="d-flex">
                  <span className="d-flex flex-column mr-3 col-6">
                    <label htmlFor="upload-period1">
                      Data {props.page === "authModuleArchive" ? "Stato" : ""}{" "}
                      Inizio
                    </label>
                    <label>
                      <DatePicker
                        showIcon
                        dateFormat="dd / MM / yyyy"
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        minDate={
                          props.page === "home"
                            ? new Date(dateNinetyDaysEarlier)
                            : null
                        }
                        maxDate={
                          props.page === "home" ||
                          props.page === "externalFlows"
                            ? new Date()
                            : null
                        }
                        id="upload-period1"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                    </label>
                  </span>
                  <span className="d-flex flex-column col-6">
                    <label htmlFor="upload-period2">
                      Data {props.page === "authModuleArchive" ? "Stato" : ""}{" "}
                      fine
                    </label>
                    <label>
                      <DatePicker
                        showIcon
                        dateFormat="dd / MM / yyyy"
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        minDate={
                          props.page === "home"
                            ? new Date(dateNinetyDaysEarlier)
                            : null
                        }
                        maxDate={
                          props.page === "home" ||
                          props.page === "externalFlows"
                            ? new Date()
                            : null
                        }
                        id="upload-period2"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                    </label>
                  </span>
                </div>
              </div>
              <div className="col-2 mr-3 mt-3 d-flex align-items-center justify-content-between col-12">
                <Button className="mr-2 rounded-0 clear" onClick={clearFilters}>
                  Svuota i campi
                </Button>
                <Button color="primary" onClick={applyFilters}>
                  Filtra
                </Button>
              </div>
            </div>
          )}
          {!filtersOpen && isFilted && (
            <div className="pb-3">
              <hr />
              {selectedFilters.typology !== null &&
                selectedFilters.typology !== "" &&
                selectedFilters.typology.length > 0 && (
                  <Chip simple color="info" className="chip-table">
                    <ChipLabel>
                      <span className="filter-name">Tipologia:</span>
                      {selectedFilters.typology.map(
                        (type) => `${type.label}; `
                      )}
                    </ChipLabel>
                  </Chip>
                )}
              {selectedFilters.flowStatus !== null &&
                selectedFilters.flowStatus !== "" &&
                selectedFilters.flowStatus.length > 0 && (
                  <Chip simple color="info" className="chip-table">
                    <ChipLabel>
                      <span className="filter-name">Stato:</span>
                      {selectedFilters.flowStatus.map(
                        (status) => `${status.label}; `
                      )}
                    </ChipLabel>
                  </Chip>
                )}
              {selectedFilters.startDate !== undefined &&
                selectedFilters.startDate !== null && (
                  <Chip simple color="info">
                    <ChipLabel>
                      <span className="filter-name">Dal: </span>
                      {selectedFilters.startDate.getDate() < 10
                        ? "0" + selectedFilters.startDate.getDate()
                        : selectedFilters.startDate.getDate()}
                      /
                      {selectedFilters.startDate.getMonth() + 1 < 10
                        ? "0" + (selectedFilters.startDate.getMonth() + 1)
                        : selectedFilters.startDate.getMonth() + 1}
                      /{selectedFilters.startDate.getFullYear()}
                    </ChipLabel>
                  </Chip>
                )}
              {selectedFilters.endDate !== undefined &&
                selectedFilters.endDate !== null && (
                  <Chip simple color="info">
                    <ChipLabel>
                      <span className="filter-name">Al: </span>
                      {selectedFilters.endDate.getDate() < 10
                        ? "0" + selectedFilters.endDate.getDate()
                        : selectedFilters.endDate.getDate()}
                      /
                      {selectedFilters.endDate.getMonth() + 1 < 10
                        ? "0" + (selectedFilters.endDate.getMonth() + 1)
                        : selectedFilters.endDate.getMonth() + 1}
                      /{selectedFilters.endDate.getFullYear()}
                    </ChipLabel>
                  </Chip>
                )}
            </div>
          )}
        </div>
      )}

      {props.page === "flow-details" && (
        <div className="form-row align-items-center rounded border border-secondary p-2 w-100 mb-3">
          <Col xs={"6"} className="m-2">
            <h3>Filters:</h3>
          </Col>
          <Col xs={"6"} className="m-2">
            <div className="input-group">
              <label className="mt-4 mr-4" htmlFor="client">
                Citizen Fiscal Code
              </label>
              <input type="text" className="form-control" id="client" />
            </div>
          </Col>
          <Col xs={"6"} className="m-2">
            <div className="input-group">
              <label className="mt-4 mr-4" htmlFor="client">
                NAV Code
              </label>
              <input type="text" className="form-control" id="client" />
            </div>
          </Col>
          <Col xs={"10"} className="m-2">
            <div className="input-group">
              <label className="mt-4 mr-4" htmlFor="client">
                Flow Status
              </label>
              <select name="status" id="status" multiple>
                <option value="IN_VALIDATION">IN_VALIDATION</option>
                <option value="ACCEPTED">ACCEPTED</option>
                <option value="DELIVERING">DELIVERING</option>
                <option value="DELIVERED">DELIVERED</option>
                <option value="VIEWED">VIEWED</option>
                <option value="EFFECTIVE_DATE">EFFECTIVE_DATE</option>
                <option value="PAID">PAID</option>
                <option value="UNREACHABLE">UNREACHABLE</option>
                <option value="REFUSED">REFUSED</option>
                <option value="CANCELLED"> CANCELLED</option>
              </select>
            </div>
          </Col>
          <Col xs={"6"} className="m-2">
            <div className="input-group">
              <label className="mt-4 mr-4" htmlFor="client">
                IUN Code
              </label>
              <input type="text" className="form-control" id="client" />
            </div>
          </Col>
          <Col xs={"7"} className="m-2"></Col>
          <Col xs={"4"} className="mt-2">
            <Button className="mr-2" color="primary">
              Clear Filters
            </Button>
            <Button color="primary" onClick={applyFilters}>
              Apply Filters
            </Button>
          </Col>
        </div>
      )}

      {(props.page === "readyFlows" ||
        props.page === "authModuleFlowsNotCalculated") && (
        <div className="w-100 subheader">
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {error === null && (
            <div className="ml-2 d-flex align-items-center justify-content-between">
              <Breadcrumbs />
              <Button
                outline
                color="secondary"
                onClick={toggleFilterOpen}
                className="mr-5 filters rounded-0"
              >
                Filtri
                {!filtersOpen && <Icon icon="it-expand" className="icon" />}
                {filtersOpen && <Icon icon="it-collapse" className="icon" />}
              </Button>
            </div>
          )}
          {filtersOpen && (
            <section className="readyFlows-filters">
              <Row className="m-2">
                <fieldset className="w-100 d-flex align-items-center justify-content-start flex-wrap">
                  <span className="mr-5">Filtra per:</span>
                  {typologyOptions.map((option) => {
                    return (
                      <FormGroup
                        key={option.value}
                        check
                        className="form-check-group d-flex flex-row-reverse mr-5"
                      >
                        <Input
                          id={option.value}
                          type="checkbox"
                          onClick={(e) => {
                            setFilterCodes((prevState) => {
                              if (
                                prevState !== null &&
                                prevState !== undefined
                              ) {
                                if (e.target.checked) {
                                  const array = prevState;
                                  const index = array.findIndex(
                                    (el) => el === option.value
                                  );
                                  if (index === -1) {
                                    return [...prevState, option.value];
                                  } else {
                                    return [...prevState];
                                  }
                                } else {
                                  let array = prevState;
                                  const index = prevState.findIndex(
                                    (el) => el === option.value
                                  );
                                  if (index === 0) {
                                    array = array.slice(1);
                                  } else if (index === array.length - 1) {
                                    array = array.slice(0, array.length - 1);
                                  } else {
                                    const temp = array.slice(0, index);
                                    temp.push(
                                      ...array.slice(index + 1, array.length)
                                    );
                                    array = temp;
                                  }
                                  return array;
                                }
                              } else {
                                return [option.value];
                              }
                            });
                            props.setFilterCodesHandler((prevState) => {
                              if (
                                prevState !== null &&
                                prevState !== undefined
                              ) {
                                if (e.target.checked) {
                                  const array = prevState;
                                  const index = array.findIndex(
                                    (el) => el === option.value
                                  );
                                  if (index === -1) {
                                    return [...prevState, option.value];
                                  } else {
                                    return [...prevState];
                                  }
                                } else {
                                  let array = prevState;
                                  const index = prevState.findIndex(
                                    (el) => el === option.value
                                  );
                                  if (index === 0) {
                                    array = array.slice(1);
                                  } else if (index === array.length - 1) {
                                    array = array.slice(0, array.length - 1);
                                  } else {
                                    const temp = array.slice(0, index);
                                    temp.push(
                                      ...array.slice(index + 1, array.length)
                                    );
                                    array = temp;
                                  }
                                  return array;
                                }
                              } else {
                                return [option.value];
                              }
                            });
                          }}
                        />
                        <Label className="text-nowrap" for={option.value}>
                          {option.label}
                        </Label>
                      </FormGroup>
                    );
                  })}
                </fieldset>
              </Row>
              <div className="col-2 mr-3 mt-3 d-flex align-items-center justify-content-between col-12 pb-3">
                <Button className="rounded-0 clear" onClick={clearFilters}>
                  Svuota i campi
                </Button>
                <Button
                  color="primary"
                  onClick={(e) => {
                    setSelectedFilterCodes(filterCodes);
                    props.filter(filterCodes);
                  }}
                >
                  Filtra
                </Button>
              </div>
            </section>
          )}
        </div>
      )}
      {props.page === "externalFlows" && (
        <div className="w-100 subheader">
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          {error === null && (
            <div className="ml-2 d-flex align-items-center justify-content-between">
              <Breadcrumbs page={props.page} />
              <div className="ml-2 d-flex align-items-center justify-content-between">
                <Button
                  outline
                  color="secondary"
                  onClick={toggleFilterOpen}
                  className="mr-5 filters rounded-0"
                >
                  Filtri
                  {!filtersOpen && <Icon icon="it-expand" className="icon" />}
                  {filtersOpen && <Icon icon="it-collapse" className="icon" />}
                </Button>
                <Button
                  outline
                  color="#2CB61D"
                  className="mr-5 rounded-0 newUser"
                  onClick={(e) => props.openModalHandler()}
                >
                  {props.uploadButtonFlowLabel !== undefined
                    ? props.uploadButtonFlowLabel
                    : "+ Carica file"}
                </Button>
              </div>
            </div>
          )}
          {filtersOpen && (
            <div className="pb-2 w-100 mb-3 mt-3">
              <div className="d-flex align-items-start col-12 row">
                <div className="bootstrap-select-wrapper col-8 col-sm-6 col-md-3 mb-4">
                  <label htmlFor="clients">Tipologia</label>
                  <Select
                    id="clients"
                    isMulti={true}
                    isSearchable={true}
                    onChange={handleTypologyChange}
                    options={typologyOptions}
                    value={typology}
                    placeholder="-Seleziona-"
                    aria-label="Seleziona"
                  />
                </div>
                <div className="bootstrap-select-wrapper col-8 col-sm-6 col-md-4 mb-4">
                  <label htmlFor="status">Stato</label>
                  <Select
                    id="status"
                    isMulti={true}
                    isSearchable={true}
                    onChange={handleStatusChange}
                    options={flowStatusesOptions}
                    value={statuses}
                    formatOptionLabel={formatOptionLabel}
                    placeholder="-Seleziona-"
                    aria-label="Seleziona"
                  />
                </div>
                <div className="d-flex">
                  <span className="d-flex flex-column mr-3 col-6">
                    <label htmlFor="upload-period1">
                      {props.startDateLabel !== undefined
                        ? props.startDateLabel
                        : "Data Inizio"}
                    </label>
                    <label>
                      <DatePicker
                        showIcon
                        dateFormat="dd / MM / yyyy"
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        // minDate={new Date(dateThirtyDaysEarlier)}
                        // maxDate={new Date()}
                        id="upload-period1"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                    </label>
                  </span>
                  <span className="d-flex flex-column col-6">
                    <label htmlFor="upload-period2">
                      {props.endDateLabel !== undefined
                        ? props.endDateLabel
                        : "Data fine"}
                    </label>
                    <label>
                      <DatePicker
                        showIcon
                        dateFormat="dd / MM / yyyy"
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        // minDate={new Date(dateThirtyDaysEarlier)}
                        // maxDate={new Date()}
                        id="upload-period2"
                        onKeyDown={(e) => {
                          e.preventDefault();
                        }}
                      />
                    </label>
                  </span>
                </div>
              </div>
              <div className="col-2 mr-3 mt-3 d-flex align-items-center justify-content-between col-12">
                <Button className="mr-2 rounded-0 clear" onClick={clearFilters}>
                  Svuota i campi
                </Button>
                <Button color="primary" onClick={applyFilters}>
                  {props.applyFilterButtonLabel !== undefined
                    ? props.applyFilterButtonLabel
                    : "Filtra"}
                </Button>
              </div>
            </div>
          )}
          {!filtersOpen && isFilted && (
            <div className="pb-3">
              <hr />
              {selectedFilters.typology !== null &&
                selectedFilters.typology !== "" &&
                selectedFilters.typology.length > 0 && (
                  <Chip simple color="info" className="chip-table">
                    <ChipLabel>
                      <span className="filter-name">Tipologia:</span>
                      {selectedFilters.typology.map(
                        (type) => `${type.label}; `
                      )}
                    </ChipLabel>
                  </Chip>
                )}
              {selectedFilters.flowStatus !== null &&
                selectedFilters.flowStatus !== "" &&
                selectedFilters.flowStatus.length > 0 && (
                  <Chip simple color="info" className="chip-table">
                    <ChipLabel>
                      <span className="filter-name">Stato:</span>
                      {selectedFilters.flowStatus.map(
                        (status) => `${status.label}; `
                      )}
                    </ChipLabel>
                  </Chip>
                )}
              <Chip simple color="info">
                <ChipLabel>
                  <span className="filter-name">Dal: </span>
                  {selectedFilters.startDate !== undefined &&
                    `${
                      selectedFilters.startDate.getDate() < 10
                        ? "0" + selectedFilters.startDate.getDate()
                        : selectedFilters.startDate.getDate()
                    }/${
                      selectedFilters.startDate.getMonth() + 1 < 10
                        ? "0" + (selectedFilters.startDate.getMonth() + 1)
                        : selectedFilters.startDate.getMonth() + 1
                    }/${selectedFilters.startDate.getFullYear()}`}
                </ChipLabel>
              </Chip>
              <Chip simple color="info">
                <ChipLabel>
                  <span className="filter-name">Al: </span>{" "}
                  {selectedFilters.endDate !== undefined &&
                    `${
                      selectedFilters.endDate.getDate() < 10
                        ? "0" + selectedFilters.endDate.getDate()
                        : selectedFilters.endDate.getDate()
                    }/${
                      selectedFilters.endDate.getMonth() + 1 < 10
                        ? "0" + (selectedFilters.endDate.getMonth() + 1)
                        : selectedFilters.endDate.getMonth() + 1
                    }/${selectedFilters.endDate.getFullYear()}`}
                </ChipLabel>
              </Chip>
            </div>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default Filters;
